import { List, ListItemButton, ListItemText } from "@mui/material";
import { LoadingGuard } from "../../components/LoadingGuard";
import { ChallengeDetails } from "../../types/cityEscape";

export type EnigmasListProps = {
  enigmas: ChallengeDetails[];
  isLoading?: boolean;
  selectedId?: string;
  onSelection: (enigma: ChallengeDetails) => void;
};

export function EngimasList({
  enigmas,
  isLoading,
  selectedId,
  onSelection,
}: EnigmasListProps) {
  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <LoadingGuard isLoading={isLoading}>
      <List id="enigmas-list">
        {enigmas.map((enigma, i, array) => (
          <ListItemButton
            selected={selectedId === enigma.id}
            key={i}
            divider={i < array.length - 1}
            onClick={() => {
              onSelection(enigma);
            }}
          >
            <ListItemText
              children={
                <div
                  dangerouslySetInnerHTML={{ __html: enigma.textContent }}
                ></div>
              }
            />
          </ListItemButton>
        ))}
      </List>
    </LoadingGuard>
  );
}
